import * as React from 'react';
import { Image, LinkButton, ModalWindow, UIHeading4, UIText2 } from '@cian/ui-kit';
import { IconPlaceholderBuilder16 } from '@cian/ui-kit-design-tokens/icons';

import { formatPhone, formatPhoneLink } from '../../../../utils/formatters';
import * as styles from './PhoneDetailsPopup.css';

export interface IPhoneDetailsPopupProps {
  builderLogoUrl?: string;
  builderName?: string;
  onClose(): void;
  onPhoneClick?(): void;
  open: boolean;
  phone: string;
}

export const PhoneDetailsPopup: React.FC<IPhoneDetailsPopupProps> = ({
  builderLogoUrl,
  builderName,
  onClose,
  onPhoneClick,
  open,
  phone,
}) => {
  return (
    <ModalWindow open={open} onClose={onClose}>
      <div className={styles['container']} data-testid="PhoneDetailsPopup">
        {builderName && builderLogoUrl && (
          <div className={styles['builder']}>
            <div className={styles['logo']}>
              <Image src={builderLogoUrl} objectFit="contain" borderRadius={0} />
            </div>
            <div className={styles['info']}>
              <div className={styles['builder-name']}>
                <UIHeading4 as="h3">{builderName}</UIHeading4>
              </div>
              <UIText2 as="p" color="text-positive-default">
                <IconPlaceholderBuilder16 color="current_color" display="inline" />
                <span className={styles['builder-label']}> Застройщик</span>
              </UIText2>
            </div>
          </div>
        )}
        <LinkButton href={formatPhoneLink(phone)} onClick={onPhoneClick} size="M" theme="stroke_primary" fullWidth>
          {formatPhone(phone)}
        </LinkButton>
      </div>
    </ModalWindow>
  );
};
